import { SupplierResponseInterface } from '../../../../../shared/interfaces/survey.interface';

export interface Multiplier {
  perform(multiplier: number): void;
}

export class SupplierCpi {
  constructor(public readonly supplier: SupplierResponseInterface) {}

  public adjust(multiplier: number = 0): number {
    // In grouped supplier case, no need to add factor of pricing multiplier
    if (this.supplier.group_ref) {
      if (!this.supplier.cpi) {
        return 0;
      }
      return this._price(this.supplier.cpi);
    }

    // Adding pricing multiplier into the CPI calculation
    const cpi = this.supplier.block_price || 0;
    return multiplier ? this._price(multiplier * cpi) : this._price(cpi);
  }

  private _price(value: number): number {
    return parseFloat(value.toFixed(2));
  }
}

export class OverrideCpiMultiplier implements Multiplier {
  constructor(public readonly suppliers: SupplierResponseInterface[]) {}

  perform(multiplier: number): void {
    this.suppliers.forEach((supplier) => {
      const cpi = new SupplierCpi(supplier);
      supplier.override_block_price = cpi.adjust(multiplier);
    });
  }
}

export class CpiMultiplier implements Multiplier {
  constructor(public readonly suppliers: SupplierResponseInterface[]) {}
  perform(multiplier: number): void {
    this.suppliers.forEach((supplier) => {
      const cpi = new SupplierCpi(supplier);
      supplier.cpi = cpi.adjust(multiplier);
      supplier.override_block_price = supplier.cpi;
    });
  }
}

export class PriceMultiplier {
  constructor(public readonly suppliers: SupplierResponseInterface[]) {}

  public calculate(
    pricingMultiplier: number,
    manualOperatorOverride: boolean,
    surveyPriceOverride: number = 0
  ): void {
    const multiplier = this.multiplier(
      manualOperatorOverride,
      surveyPriceOverride
    );

    multiplier.perform(pricingMultiplier);
  }

  public multiplier(
    manual_override: boolean,
    surveyPriceOverride: number
  ): Multiplier {
    if (manual_override || surveyPriceOverride) {
      return new OverrideCpiMultiplier(this.suppliers);
    }

    return new CpiMultiplier(this.suppliers);
  }
}
